import { render, staticRenderFns } from "./OctGlobalfooter.vue?vue&type=template&id=1541977d&scoped=true&"
import script from "./OctGlobalfooter.vue?vue&type=script&lang=js&"
export * from "./OctGlobalfooter.vue?vue&type=script&lang=js&"
import style0 from "./OctGlobalfooter.vue?vue&type=style&index=0&id=1541977d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1541977d",
  null
  
)

export default component.exports